import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const queryArticlesByPlatformId = async (params: object) => {
  return await GET({
    url: Api.queryArticlesByPlatformId,
    params,
    showError: false,
    headers: {
      rpcType: 'dubbo'
    }
  })
}

export const citySwitch = async (params: object) => {
  return await GET({
    url: Api.citySwitch,
    params
  })
}
